export const streamPerticuleWatchlist = (data, streamData) => {
    return data.map((stock) => {
        if (stock.symbol === streamData.symbol) {
            return Object.assign(Object.assign({}, stock), { lastTradedPrice: streamData.curPrice, change: streamData.changePrice, changePercentage: streamData.changePercentage });
        }
        else {
            return stock;
        }
    });
};
